/**
 * Validates if the string is email.
 * @param {string} email
 * @returns boolean
 */
export const validateEmail = email => {
  if (!email || email?.split("@")?.length !== 2) {
    return false;
  }

  const tester =
    /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
  return tester.test(email);
};

export const isValidJSON = item => {
  try {
    JSON.parse(item);
    return true;
  } catch {
    return false;
  }
};

export function isValidURL(string) {
  const res = string.match(
    /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi
  );
  return res !== null;
}
